import { connect } from 'react-redux';
import { showOnboarding, disableOnboarding } from 'actions/Onboarding';
import { JOIN_MODAL } from 'constants/JoinModal';
import { FIRST_TIME_USER_SETTING } from 'constants/UserSettings';
import { currentUserSelectors } from '@lifesize/nucleus';
import GetPermission from 'components/GetPermission/GetPermission';
import _get from 'lodash/get';

function mapStateToProps(state) {
  return {
    firstTimeUser: _get(currentUserSelectors.myInfo(state), ['userSettings', FIRST_TIME_USER_SETTING]),
    isAcquiringPrimaryStream: _get(state, 'nucleus.media.isAcquiringPrimaryStream'),
    showPermissionPage: _get(state, 'nucleus.media.isPendingPermissions') && _get(state, 'app.modal.visibleComponent') !== JOIN_MODAL
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showOnboarding: () => {
      dispatch(showOnboarding());
    },
    disableOnboarding: () => {
      dispatch(disableOnboarding());
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(GetPermission);
